import { useViewerActions } from '../../hooks/useViewerActions';
import HR from 'UIComponents/elements/HR';
import ViewerConditionClickableBox from './ViewerConditionClickableBox';
import ViewerRelatedConditionsHeadingText from './ViewerRelatedConditionsHeadingText';
import { useFlexibleAssociations } from '../../hooks/useFlexibleAssociations';
import { useMemo } from 'react';
import { useStrategy } from '../../hooks/useStrategy';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import MatchStatusIcon from './MatchStatusIcon';
import styled from 'foundations-theming/utils';
import { useUnifiedEventCompletionStatus } from '../../hooks/useUnifiedEventCompletionStatus';
import ViewerAssociatedCrmObjectHeadingSubtext from './ViewerAssociatedCrmObjectHeadingSubtext';
import ViewerUnifiedEventRefinementsDisplay from './ViewerUnifiedEventRefinementsDisplay';
import LogicGroupError from '../common/LogicGroupError';
import { DisallowedAdIntegrationFilterFamilies } from '../../converters/listSegClassic/ListSegConstants';
import DisabledAdIntegrationWarning from './DisabledAdIntegrationWarning';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ViewerRelatedConditionsHeadingTextWrapper = styled.div.withConfig({
  displayName: "ViewerRelatedConditionsHeading__ViewerRelatedConditionsHeadingTextWrapper",
  componentId: "sc-1r2ebm1-0"
})(() => ({
  overflowWrap: 'break-word'
}));
const ViewerAssociatedCrmObjectHeadingSubtextWrapper = styled.div.withConfig({
  displayName: "ViewerRelatedConditionsHeading__ViewerAssociatedCrmObjectHeadingSubtextWrapper",
  componentId: "sc-1r2ebm1-1"
})(({
  theme
}) => ({
  overflowWrap: 'break-word',
  // The 1px margin offsets the 1px border that is added to the condition
  marginLeft: theme.space[25],
  paddingLeft: theme.space[100],
  paddingTop: theme.space[100]
}));
const ViewerRelatedConditionsHeading = props => {
  const {
    conditionPath,
    logicGroup,
    matchStatus
  } = props;
  const {
    onEditFilter
  } = useViewerActions();
  const {
    isAssnBranch,
    showAssociationSelect
  } = useFlexibleAssociations(logicGroup, conditionPath);
  const {
    showUnifiedEventCompletionStatusSelect
  } = useUnifiedEventCompletionStatus(logicGroup, conditionPath);
  const {
    isTestFiltersEnabled
  } = useStrategy();
  const isClickable = useMemo(() => {
    return showAssociationSelect || showUnifiedEventCompletionStatusSelect;
  }, [showAssociationSelect, showUnifiedEventCompletionStatusSelect]);
  const onClick = evt => {
    evt.stopPropagation();
    onEditFilter(conditionPath, logicGroup.filterFamily);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ViewerConditionClickableBox, {
      condition: logicGroup,
      conditionPath: conditionPath,
      filterFamily: logicGroup.filterFamily,
      onClick: onClick,
      deleteOnly: !isClickable,
      isInConditionContentBox: true,
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "between",
        children: [/*#__PURE__*/_jsxs(ViewerRelatedConditionsHeadingTextWrapper, {
          children: [/*#__PURE__*/_jsx(ViewerRelatedConditionsHeadingText, {
            logicGroup: logicGroup,
            conditionPath: conditionPath
          }), /*#__PURE__*/_jsx(ViewerUnifiedEventRefinementsDisplay, {
            logicGroup: logicGroup
          })]
        }), isTestFiltersEnabled && matchStatus && /*#__PURE__*/_jsx(Box, {
          alignSelf: "start",
          children: /*#__PURE__*/_jsx(MatchStatusIcon, {
            matchStatus: matchStatus
          })
        })]
      }), /*#__PURE__*/_jsx(LogicGroupError, {
        logicGroup: logicGroup,
        showLogicGroupErrors: true,
        spaceStyleProps: {
          marginBlockStart: '0',
          marginInlineStart: '100'
        }
      }), DisallowedAdIntegrationFilterFamilies.includes(logicGroup.filterFamily) && /*#__PURE__*/_jsx(DisabledAdIntegrationWarning, {})]
    }), isAssnBranch && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HR, {
        className: "m-y-1",
        "data-test-id": "association-divider"
      }), /*#__PURE__*/_jsx(ViewerAssociatedCrmObjectHeadingSubtextWrapper, {
        children: /*#__PURE__*/_jsx(ViewerAssociatedCrmObjectHeadingSubtext, {
          logicGroup: logicGroup
        })
      })]
    })]
  });
};
export default ViewerRelatedConditionsHeading;